import GeneralTab from "./tabs-General.jsx";
import AffiliateTab from "./tabs-Affiliate.jsx";
import HistoryTab from "./tabs-History.jsx";
import BalanceTab from "./tabs-Balance.jsx";
import RewardPointsTab from "./tabs-RewardPoints.jsx";
import CustomerTierTab from "./tabs-CustomerTier.jsx";
import IpAddressesTab from "./tabs-IpAddresses.jsx";
import OrderHistoryTab from "./tabs-OrderHistory.jsx";
import OrderScheduleTab from "./tabs-OrderSchedule.jsx";
import { default as AddressesTab } from "./tabs-Addresses";

export {
  GeneralTab,
  AffiliateTab,
  HistoryTab,
  BalanceTab,
  RewardPointsTab,
  CustomerTierTab,
  IpAddressesTab,
  OrderHistoryTab,
  OrderScheduleTab,
  AddressesTab,
};

